// extracted by mini-css-extract-plugin
module.exports = {"numberTableValue":"QkcYw4Ov"};